// ----------------------------------------------------------------------

// Press feedback should be crisp, not a floaty spring: a subtle scale on a fast
// ease-out tween so the button feels like it heard the press immediately.
const CLICK_TRANSITION = { duration: 0.12, ease: [0.23, 1, 0.32, 1] };

export const varHover = {
  hover: { scale: 1.05, transition: CLICK_TRANSITION },
};

export const varSmallClick = {
  hover: { scale: 1.03, transition: CLICK_TRANSITION },
  tap: { scale: 0.97, transition: CLICK_TRANSITION },
};

export const varMediumClick = {
  hover: { scale: 1.05, transition: CLICK_TRANSITION },
  tap: { scale: 0.95, transition: CLICK_TRANSITION },
};
